module.exports = __webpack_public_path__ + "static/IBMPlexSans-Text-12509db504eb4e2cae98c559c28aa44c.woff";